<template>
  <div class="summary-answer">
    <component
      :is="question.type"
      v-bind="question.data"
      :image="question.image"
      :expected-response="question.expectedResponse"
    />
  </div>
</template>

<script>
import { VvCheckboxBubble, VvScale } from '@/components/common'

import SummaryAnswer from './answers'

export default {
  name: 'SummaryAnswer',
  components: { VvCheckboxBubble, VvScale, ...SummaryAnswer },
  props: {
    question: Object
  }
}
</script>

<style scoped lang="scss">
.summary-answer {
  margin-bottom: 30px;
}
</style>
